import { render } from "./TheFooterAuthMobile.vue?vue&type=template&id=4e61c5c6&scoped=true"
const script = {}

import "./TheFooterAuthMobile.vue?vue&type=style&index=0&id=4e61c5c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e61c5c6"]])

export default __exports__